import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import classNames from 'classnames'

import WebTransferFormNotes from '../webTransferInfo/WebTransferFormNotes'

class GeneralInfoNoteButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowNotes: true,
    }
  }

  handleToggleNotes = () => {
    this.setState(prevState => ({ isShowNotes: !prevState.isShowNotes }))
  }

  render() {
    if (_.isEmpty(this.props.notes)) {
      return null
    }

    return (
      <ButtonLayout>
        <button
          className="button is-info is-rounded"
          style={{ marginBottom: 16 }}
          onClick={this.handleToggleNotes}
        >
          <span className="icon" key={this.state.isShowNotes}>
            <i
              className={classNames('fas', {
                'fa-arrow-up': !this.state.isShowNotes,
                'fa-arrow-down': this.state.isShowNotes,
              })}
            />
          </span>
          <span>Notes</span>
        </button>

        {this.state.isShowNotes && (
          <NoteLayout>
            <WebTransferFormNotes notes={this.props.notes} />
          </NoteLayout>
        )}
      </ButtonLayout>
    )
  }
}

const ButtonLayout = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
  max-width: 500px;
  min-width: 350px;
  //width: 20%;
  padding-top: 64px;
  padding-right: 16px;
  text-align: right;
`

const NoteLayout = styled.div`
  position: absolude;
  border: 2px solid gray;
  padding: 16px;
  background: white;
  text-align: left;
`

export default GeneralInfoNoteButton



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoNoteButton.js